import React, { useEffect, useState } from "react";
import Button from "../../components/Buttons/Button";
import { ConfirmModal } from "../../components/Modals";
import { clearIcon as ClearIcon, closeIcon as CloseIcon, delIcon as DelIcon } from "assets/icons";
import {
  CloseButton,
  Divider,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalPanel,
  NoteTextArea,
  Toolbar,
  ToolbarButton,
} from "./LeadNoteModal.styles";

interface LeadNoteModalProps {
  isOpen: boolean;
  initialNote: string;
  isSaving?: boolean;
  onClose: () => void;
  onSave: (note: string) => void | Promise<void>;
  onDelete: () => void | Promise<void>;
}

const LeadNoteModal: React.FC<LeadNoteModalProps> = ({
  isOpen,
  initialNote,
  isSaving = false,
  onClose,
  onSave,
  onDelete,
}) => {
  const [note, setNote] = useState(initialNote);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setNote(initialNote || "");
      setIsDeleteConfirmOpen(false);
    }
  }, [initialNote, isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay onMouseDown={onClose}>
        <ModalPanel
          role="dialog"
          aria-modal="true"
          aria-labelledby="lead-note-modal-title"
          onMouseDown={(event) => event.stopPropagation()}
        >
          <ModalHeader>
            <h2 id="lead-note-modal-title">Заметки</h2>
            <CloseButton type="button" aria-label="Закрыть заметку" onClick={onClose}>
              <CloseIcon aria-hidden="true" />
            </CloseButton>
          </ModalHeader>
          <Divider />
          <ModalBody>
            <Toolbar>
              <ToolbarButton
                type="button"
                aria-label="Очистить текст"
                onClick={() => setNote("")}
                disabled={isSaving || note.length === 0}
              >
                <ClearIcon aria-hidden="true" />
              </ToolbarButton>
              <ToolbarButton
                type="button"
                aria-label="Удалить заметку"
                onClick={() => setIsDeleteConfirmOpen(true)}
                disabled={isSaving || initialNote.length === 0}
              >
                <DelIcon aria-hidden="true" />
              </ToolbarButton>
            </Toolbar>
            <NoteTextArea
              autoFocus
              value={note}
              onChange={(event) => setNote(event.target.value)}
              placeholder="Напишите текст"
              disabled={isSaving}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              variant="primary"
              fullWidth
              loading={isSaving}
              disabled={isSaving}
              onClick={() => onSave(note)}
            >
              Сохранить
            </Button>
          </ModalFooter>
        </ModalPanel>
      </ModalOverlay>

      <ConfirmModal
        isOpen={isDeleteConfirmOpen}
        title="Удаление заметки"
        message="Вы уверены, что хотите удалить заметку? Это действие нельзя будет отменить."
        onConfirm={() => {
          setIsDeleteConfirmOpen(false);
          void onDelete();
        }}
        onCancel={() => setIsDeleteConfirmOpen(false)}
      />
    </>
  );
};

export default LeadNoteModal;
